import { VerticalView } from 'src/components/FlexViews';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { WelcomeBonusModal } from './components/WelcomeBonusModal';
import { PageWrapper } from '../../ui/common';
import { ReactComponent as CoinIcon } from 'src/assets/icons/bonus-game/tether-coin.svg';
import { ReactComponent as MedalGold } from 'src/assets/icons/bonus-game/season-silver-medal.svg';
import { ReactComponent as MedalSilver } from 'src/assets/icons/bonus-game/season-silver-medal.svg';
import { ReactComponent as MedalBronze } from 'src/assets/icons/bonus-game/season-bronze-medal.svg';
import { ReactComponent as MedalRegular } from 'src/assets/icons/bonus-game/season-regular-medal.svg';
import discordBlur from 'src/assets/img/bonus-game/discord-blur.webp';
import seasonBonus from 'src/assets/img/bonus-game/season-bonus.webp';
import { Button } from '../../components/Button';

const ModalWrapper = styled(VerticalView)`
  position: relative;
  border-radius: 12px;
  border: 1px solid #29313e;
  background: #171d25;
  padding: 32px 24px;
`;

const AwardCard = styled.img`
  margin-bottom: 20px;
`;

const AwardItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #ffffff;
`;

const LeaderboardItem = styled.div<{ place: number }>`
  background-color: #1a222c;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const MedalWrapper = styled.div`
  position: relative;
  margin-right: 10px;
`;

const MedalPosition = styled.p`
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  font-family: Public-Sans, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 12px;
  color: rgba(0, 0, 0, 0.8);
  text-align: center;
  white-space: nowrap;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

const UserName = styled.div`
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
`;

const UserScore = styled.div<{ place?: number }>`
  display: flex;
  align-items: center;
  gap: 5px;
  color: #ffffff;
  position: relative;
`;

const DiscordSection = styled.div`
  overflow: hidden;
  background-color: #ffffff14;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 30px 0;
`;

const DiscordInfo = styled.div`
  flex: 1;
  gap: 8px;
  padding: 20px;
`;

const DiscordTitle = styled.div`
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 700;
`;

const DiscordText = styled.div`
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  font-weight: 500;
`;

const DiscordIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Ellipse = styled.div`
  position: absolute;
  right: -45px;
  top: 1.174px;
  width: 154px;
  height: 49px;
  background: #c8f744;
  filter: blur(39.37645721435547px);
  opacity: 0.3;
`;

const Title = styled.p`
  color: #aade16;
  text-align: center;
  font-family: Public-Sans, sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  margin-bottom: 20px;
`;

const medalIcons = [
  <MedalGold key={'gold'} />,
  <MedalSilver key={'silver'} />,
  <MedalBronze key={'bronze'} />,
];

const getMedalIcon = (position: number) => {
  if (position > 3) {
    return <MedalRegular />;
  }
  return medalIcons[position - 1];
};

interface LeaderboardUser {
  id?: string;
  name?: string;
  rating?: number;
  position?: number;
}

const seasonRewards = [
  { position: 2, rating: 100 },
  { position: 3, rating: 50 },
  { position: 4, rating: 30 },
  { position: 5, rating: 15 },
  { position: 6, rating: 10 },
];

export const SeasonInfo = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  return (
    <PageWrapper>
      <ModalWrapper>
        <Title>Welcome to Season Two! </Title>
        <AwardCard
          style={{ width: '100%' }}
          src={seasonBonus}
          alt="Season Leader Board"
        />

        {seasonRewards.map((user, index) => (
          <LeaderboardItem key={index} place={index + 2}>
            <UserInfo>
              <MedalWrapper>
                {getMedalIcon(index + 2)}
                <MedalPosition
                  style={{
                    color: 'rgba(0, 0, 0, 0.8)',
                    fontSize: index === 4 ? '12px' : '16px',
                  }}>
                  {index === 4 ? '6-10' : index + 2}
                </MedalPosition>
              </MedalWrapper>
              <UserName>Place</UserName>
            </UserInfo>
            <UserScore>
              <span style={{ fontSize: '16px', fontWeight: '700' }}>
                {user.rating}
              </span>
              <CoinIcon width={16} height={16} />
              {index === 0 && <Ellipse />}
              {index === 1 && <Ellipse style={{ background: '#B0823E' }} />}
            </UserScore>
          </LeaderboardItem>
        ))}

        <DiscordSection>
          <DiscordInfo>
            <DiscordTitle>Top 200 members</DiscordTitle>
            <DiscordText>
              Ambassador role on Haqabi{' '}
              <a
                style={{ color: '#5865F2' }}
                href="https://discord.gg/kXeefuKPmQ">
                Discord
              </a>
            </DiscordText>
          </DiscordInfo>
          <DiscordIconWrapper>
            <img
              style={{ objectPosition: '-35px 5px', objectFit: 'cover' }}
              src={discordBlur}
              width={'500%'}
              height={'88px'}
            />
          </DiscordIconWrapper>
        </DiscordSection>
        <Button
          title="Start"
          style={{ color: '#AADE16' }}
          onClick={() => setShowModal(true)}
        />
        {showModal && <WelcomeBonusModal setShowModal={setShowModal} />}
      </ModalWrapper>
    </PageWrapper>
  );
};
